<template>
    <ion-refresher slot="fixed" pull-factor="0.5" pull-min="100" pull-max="200" @ionRefresh="setup">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <Loading v-if="loading"></Loading>

    <ion-list v-if="getNotifications.length > 0" ref="notifications_list">
        <div v-for="(notification, index) in getNotifications" :key="index">
            <ion-item-sliding>
                <ion-item button @click="goTo(notification)" :class="notification.read_at ? null : 'unread'">
                    <ion-avatar slot="start" class="notifications-avatar">
                        <mdicon v-if="notification.data.icon == 'chat'" name="chat-outline" />
                        <mdicon v-else-if="notification.data.icon == 'information-circle'" name="information-outline" />
                        <mdicon v-else name="information-outline" />
                    </ion-avatar>
                    <ion-label>
                        <p class="no-truncate">{{ notification.data.message }}</p>
                        <small class="text-medium">
                            {{ $fuzzyDate(notification.created_at, true) }}
                        </small>
                    </ion-label>
                </ion-item>
                <ion-item-options>
                    <slot name="options" v-bind="notification"></slot>
                    <ion-item-option color="danger" @click="deleteNotification(notification)">
                        Verwijderen
                    </ion-item-option>
                </ion-item-options>
            </ion-item-sliding>
        </div>
    </ion-list>

    <no-data v-else icon="bell">

        <template #info>
            <p class="no-data-subtitle">
                Je hebt nog geen notificaties ontvangen
            </p>
        </template>

    </no-data>
</template>
<script>

import { db } from "@/services/db";
import {
    IonAvatar, modalController, IonItemOptions, IonItemOption, IonItemSliding, IonRefresher,
    IonRefresherContent
} from "@ionic/vue";
import EditAction from "../views/actions/Edit.vue"
import NoData from "./NoData.vue"
import { Browser } from "@capacitor/browser";
import Loading from "./Loading.vue"
import { liveQuery } from "dexie";
import PDFviewer from "./PDFviewer.vue";

export default {
    name: 'notifications-index',
    components: {
        IonAvatar,
        IonItemOptions,
        IonItemOption,
        IonItemSliding,
        NoData,
        IonRefresher,
        IonRefresherContent,
        Loading
    },
    data() {
        return {
            loading: false,
            dark_mode: false,
            notifications: [],
            subscription: null,
        }
    },
    created() {
        this.setup()
    },
    methods: {
        async deleteAll() {
            this.$requests.delete('notifications', '/notifications').then(() => {
                this.notifications = []
            })
        },
        async setup($event) {
            await this.$requests.get('notifications', '/notifications')

            const observable = liveQuery(
                async () => await db.notifications.toArray()
            );

            if (this.subscription) {
                this.subscription.unsubscribe();
            }

            this.subscription = observable.subscribe({
                next: result => {
                    this.notifications = result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                },
                error: error => console.error(error)
            });


            if ($event) {
                $event.target.complete()
            }
        },
        async goTo(notification) {
            notification.read_at = new Date().toISOString()
            this.$requests.patch('notifications', '/notifications/' + notification.id, notification).then(
                () => {
                    this.$requests.get('notifications', '/notifications')
                }
            )

            // open actions edit modal
            if (notification.data.subject_type == 'action') {
                let action = await db.actions.where({ uuid: notification.data.subject_uuid }).first()

                if (action) {
                    this.editAction(action)
                } else {
                    this.$toast.error('Deze actie is niet meer beschikbaar')
                }
            } else if (notification.data.actionText == 'Downloaden') {
                // await Browser.open({ url: notification.data.actionUrl.url })

                // open pdf preview
                const modal = await modalController.create({
                    component: PDFviewer,
                    componentProps: {
                        url: notification.data.actionUrl.url
                    },
                    initialBreakpoint: 1,
                      breakpoints: [0, 1]
                });

                await modal.present();

            } else if (notification.data.subject_type == "inspection") {
                this.openInspection(notification.data.subject_uuid)
            }
            else {
                this.$toast.error('Deze notificatie is niet beschikbaar')
            }

        },
        openInspection(inspection_uuid) {
            this.loading = true
            this.$requests.get('inspections', '/inspections').then(inspections => {
                let inspection = inspections.find(inspection => inspection.uuid == inspection_uuid)

                if (!inspection) {
                    this.$toast.error('Deze inspectie is niet meer beschikbaar')
                    this.loading = false
                    return
                }

                this.$store.dispatch('setInspectionId', inspection.id)
                this.$store.dispatch('setLocationId', inspection.location_id)
                this.$store.dispatch('setInspectionUuid', inspection.uuid)
                this.$store.dispatch('setLocationUuid', inspection.location_uuid)

                this.loading = false

                this.$router.push({
                    name: 'inspection-show',
                    params: {
                        id: inspection.id,
                    },
                    query: {
                        location_id: inspection.location_id,
                        inspection_uuid: inspection.uuid,
                        location_uuid: inspection.location_uuid,
                    }
                })
            })


            this.$store.dispatch('setShowSidebar', false)
        },
        editAction(action) {
            this.$store.dispatch('setShowSidebar', false)

            this.$router.push({ name: 'action-edit', query: { uuid: action.uuid } });
        },
        deleteNotification(notification) {
            this.$requests.delete('notifications', '/notifications/' + notification.id, notification.id).then(
                () => {
                    this.$refs.notifications_list.$el.closeSlidingItems()
                    this.notifications = this.notifications.filter(item => item.id !== notification.id)
                }
            )
        }
    },
    computed: {
        getNotifications() {
            if (this.notifications) {
                return this.notifications
            }
            return []
        },
        isAuthenticated() {
            if (localStorage.getItem('bearer') == null) {
                return false
            } else {
                return true
            }

        }
    },
}
</script>
<style lang="scss">
.notifications-avatar {
    --size: 40px;
    width: var(--size);
    height: var(--size);
    color: var(--ion-color-medium);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: unset;
    margin-inline: unset;
    margin-left: -10px;
    margin-right: 5px;
}

.unread {
    --background: var(--ion-color-light);
    border-left: 5px solid var(--ion-color-primary);
}
</style>
